import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";

import AvgMarginChart from "./AvgMarginChart";
import StatsControls from "./Controls";
import EnteredChart from "./EnteredChart";
import MarginChart from "./MarginChart";
import SoldChart from "./SoldChart";

import BackdropLoader from "../../../../components/BackdropLoader";
import InTimeStatsSkeleton from "../../../../components/skeletons/InTimeStatsSkeleton";
import { useGetCurrentCompanyBranchesQuery } from "../../../branches/branchesApiSlice";
import { useGetCurrentUserQuery } from "../../../user/userApiSlice";
import { useGetCompanyInTimeStatsQuery } from "../../statisticsApiSlice";

const InTimeStatistics = () => {
	const { data: user } = useGetCurrentUserQuery();
	const isBranchManager = user?.role === "branch-manager";

	const {
		data: branches,
		error: branchesError,
		isLoading: isLoadingBranches,
	} = useGetCurrentCompanyBranchesQuery();

	const [branchValue, setBranchValue] = useState(
		isBranchManager ? user?.company_branch_id : ""
	);
	const onBranchChange = (e) => {
		e.preventDefault();
		setBranchValue(e.target.value);
	};

	const [yearRange, setYearRange] = useState();

	const [weightValues, setWeightValues] = useState({ from: "", to: "" });
	const onWeightChange = (e, type) => {
		e.preventDefault();

		if (type === "from") {
			setWeightValues({ ...weightValues, from: e.target.value });
		} else {
			setWeightValues({ ...weightValues, to: e.target.value });
		}
	};

	const [filterValues, setFilterValues] = useState({
		branch: isBranchManager ? user?.company_branch_id : "",
		range: "",
		weightFrom: "",
		weightTo: "",
	});
	const [isRefetching, setIsRefetching] = useState(false);

	const {
		data: stats,
		error,
		isLoading,
		refetch,
	} = useGetCompanyInTimeStatsQuery(filterValues);

	useEffect(() => {
		setIsRefetching(false);
	}, [stats, error]);

	const handleSubmit = async () => {
		setIsRefetching(true);
		const parsedRange = yearRange
			? [yearRange.startYear, yearRange.endYear]
			: "";

		if (
			filterValues.branch === branchValue &&
			filterValues.range === encodeURIComponent(parsedRange) &&
			filterValues.weightFrom === weightValues.from &&
			filterValues.weightTo === weightValues.to
		) {
			await refetch();
			return;
		}

		setFilterValues({
			branch: branchValue,
			range: encodeURIComponent(parsedRange),
			weightFrom: weightValues.from,
			weightTo: weightValues.to,
		});
	};

	if (isLoading || isLoadingBranches) {
		return <InTimeStatsSkeleton />;
	}

	return (
		<>
			<Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
				<StatsControls
					disableBranchSelect={isBranchManager}
					isLoading={isRefetching}
					onSubmit={handleSubmit}
					onBranchChange={isBranchManager ? () => {} : onBranchChange}
					branchValue={branchValue}
					branchOptions={branches.map((branch) => {
						return { value: branch.id, label: branch.name };
					})}
					yearRange={yearRange}
					setYearRange={setYearRange}
					weightFrom={weightValues.from}
					onWeightFromChange={(e) => onWeightChange(e, "from")}
					weightTo={weightValues.to}
					onWeightToChange={(e) => onWeightChange(e, "to")}
				/>
				<Grid container rowSpacing={5}>
					<Grid size={6}>
						<EnteredChart data={stats} />
					</Grid>
					<Grid size={6}>
						<SoldChart data={stats} />
					</Grid>
					<Grid size={6}>
						<MarginChart data={stats} />
					</Grid>
					<Grid size={6}>
						<AvgMarginChart data={stats} />
					</Grid>
				</Grid>
			</Box>
			<BackdropLoader isOpen={isRefetching} />
		</>
	);
};

export default InTimeStatistics;
